import React from "react"
import { Container } from "react-bootstrap"
import { useDispatch } from "react-redux"
import {
  increment,
  decrement,
  controlLoading,
  controlDeclaration,
  updateClickedNext,
  editAllInvalidForm,
  generateFolderName,
  resetSelectDocument,
  storeDocumentList,
  editUpload,
  updateCategoryClaimData,
  updateUiData,
} from "../../../Redux/WindscreenClaim/actions"
import * as API from "../../../services/httpService"
import Swal from "sweetalert2"
import * as Constants from "../../../common/constants"
import {
  missingInfoAlert,
  missingDescriptionOfDamage,
  missingProvideDocumentProofOfClaimAlert,
  missingProvidePoliceReport,
  windscreenPolicyValidationAlert,
  windscreenPolicyWithoutVehicleNoValidationAlert,
  pleaseAgreeAlert,
  pleaseCheckInfoAlert,
  notAllowedClaimAlert,
  accidentDateWithinPolicyPeriodAlert,
} from "../../../services/sweetalertService"
import { navigate } from "gatsby"
import SubmitClaim from "./SubmitClaim"

const WindscreenClaimFooter = ({ pageNumber, uiData, claimData }) => {
  const dispatch = useDispatch()
  const { claimUploadListModel, proofDocuments, isEditUpload } = uiData

  const ClearDataWarning = Swal.mixin({
    customClass: {
      confirmButton: "swal-button--back",
      cancelButton: "swal-button--next",
      actions: "swal-footer",
    },
    buttonsStyling: false,
  })

  const driverInfoFormName = "Particulars of Driver"
  const accidentFormName = "Particulars of Accident"
  const reviewFormName = "Review Policy Information"

  const checkMandatoryUploadDocument = () => {
    let mandatoryList = []

    mandatoryList = proofDocuments.filter(x => x.mandatory)

    let isUploaded = false

    //reversed for loop, because splice function inside loop
    for (let i = mandatoryList.length - 1; i >= 0; --i) {
      isUploaded = false
      claimUploadListModel.forEach(
        (currentCoverageItem, currentCoverageKey) => {
          if (
            !isUploaded &&
            mandatoryList[i].documentId === currentCoverageItem.documentId
          ) {
            mandatoryList.splice(i, 1)
            isUploaded = true
          }
        }
      )
    }

    //If mandatoryList is empty will pass mandatory file validation
    return mandatoryList.length < 1 ? true : false
  }

  const nextPage = () => {
    //reset select document list everytime we click next
    // dispatch(resetSelectDocument())
    switch (pageNumber) {
      case 1:
        dispatch(updateClickedNext("Policy Information"))
        if (uiData.formIsValid["Policy Information"]) {
          const userEnteredPolicyNumber =
            claimData.claimInfo.policyInfo.policyNumber

          const masterAccountPatternRegex = RegExp(
            Constants.masterAccountPattern
          )
          const policyPatternRegex = RegExp(Constants.policyPattern)

          //Validate user entered data is policy number or master account
          if (policyPatternRegex.test(userEnteredPolicyNumber)) {
            getPolicyInfoAPI()
            dispatch(updateUiData("isMasterAccClaim", false))
          }
          if (masterAccountPatternRegex.test(userEnteredPolicyNumber)) {
            //Must update to call Tiqconnect API
            getPolicyInfoAPI()
            dispatch(updateUiData("isMasterAccClaim", true))
            dispatch(
              updateCategoryClaimData(
                "claimInfo",
                "policyInfo",
                "masterAccountNumber",
                userEnteredPolicyNumber
              )
            )
          }
        } else {
          missingInfoAlert()
        }
        break

      case 2:
        if (
          //claimUploadListModel.length < 1 &&
          !checkMandatoryUploadDocument() &&
          process.env.NODE_ENV !== "development"
        ) {
          missingProvideDocumentProofOfClaimAlert()
        } else {
          dispatch(resetSelectDocument())
          dispatch(increment())
        }
        break

      case 3:
        dispatch(updateClickedNext(driverInfoFormName))
        if (uiData.formIsValid[driverInfoFormName]) {
          dispatch(increment())
        } else {
          missingInfoAlert()
        }
        break

      case 4:
        dispatch(updateClickedNext(accidentFormName))
        if (
          uiData.formIsValid[accidentFormName] &&
          !(
            claimData["claimInfo"]["policyInfo"].natureOfDamage ===
              Constants.natureOfDamageOther &&
            claimData["claimInfo"]["policyInfo"].otherNatureOfDamage.trim() ===
              ""
          )
        ) {
          if (claimData.claimInfo.claimWindscreenItems.length > 0) {
            if (
              !checkMandatoryUploadDocument() &&
              process.env.NODE_ENV !== "development"
            ) {
              missingProvidePoliceReport()
              dispatch(editUpload())
            } else {
              dispatch(increment())
            }
          } else {
            missingDescriptionOfDamage()
          }
        } else {
          missingInfoAlert()
        }
        break

      case 5:
        //Check if user select vandalism desc of damage, need provide police report
        if (
          !checkMandatoryUploadDocument() &&
          process.env.NODE_ENV !== "development"
        ) {
          missingProvidePoliceReport()
          dispatch(editUpload())
          return
        }

        //Check any form is not pass validation and show it
        let finalValidatePass = true
        let invalidForm = []
        if (!uiData.formIsValid[driverInfoFormName]) {
          invalidForm.push(driverInfoFormName)
          finalValidatePass = false
        }
        if (
          !uiData.formIsValid[accidentFormName] ||
          (claimData["claimInfo"]["policyInfo"].natureOfDamage ===
            Constants.natureOfDamageOther &&
            claimData["claimInfo"]["policyInfo"].otherNatureOfDamage.trim() ===
              "")
        ) {
          invalidForm.push(accidentFormName)
          finalValidatePass = false
        }
        if (!uiData.formIsValid[reviewFormName]) {
          invalidForm.push(reviewFormName)
          finalValidatePass = false
        }
        if (!finalValidatePass) {
          dispatch(editAllInvalidForm(invalidForm))
          pleaseCheckInfoAlert()
          return
        }

        //Check Description of Damage is not empty
        if (claimData.claimInfo.claimWindscreenItems.length > 0) {
          if (!uiData.showDeclaration) {
            dispatch(controlDeclaration())
          } else {
            if (!uiData.checkBoxStatus.isAgree) {
              pleaseAgreeAlert()
            } else {
              dispatch(controlLoading())
              SubmitClaim(dispatch, uiData, claimData)
            }
          }
        } else {
          missingDescriptionOfDamage()
        }
        break

      default:
        dispatch(increment())
    }
  }

  const previousPage = () => {
    switch (pageNumber) {
      case 2:
        ClearDataWarning.fire({
          title:
            "Are you sure you want to go back to the first page? This will be remove all the data you have entered.",
          //icon: "warning",
          scrollbarPadding: false,
          showCancelButton: true,
          confirmButtonColor: "#ff3333",
          cancelButtonColor: "#fff",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          focusConfirm: false,
        }).then(result => {
          if (result.value) {
            let deleteMultipleFileArray = []

            claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
              let deleteFileInfo = {}
              deleteFileInfo.fName = UploadedItem.fileName
              deleteFileInfo.folderName = uiData.folderName
              deleteMultipleFileArray.push(deleteFileInfo)
            })

            API.apiPostRequest(
              "/Claim/ClaimDocsMultipleDelete",
              deleteMultipleFileArray,
              null
            ).then(response => {})
            dispatch(decrement())
          }
          return false
        })
        break
      case 5:
        if (uiData.showDeclaration) {
          dispatch(controlDeclaration())
        } else {
          dispatch(decrement())
        }
        break
      case 4:
        dispatch(resetSelectDocument())
        dispatch(decrement())

        break

      default:
        dispatch(decrement())
    }
  }

  const hideBackButton = () => {
    //return true is hide the Back Button
    if (isEditUpload) return true

    switch (pageNumber) {
      case 1:
        return true
      default:
    }
  }

  const hideNextButton = () => {
    //return true is hide the Next Button
    switch (pageNumber) {
      default:
    }
  }

  const getPolicyInfoAPI = () => {
    dispatch(controlLoading())

    const validatePolicyPromise = API.apiPostRequest(
      "/Claim/WindscreenValidatePolicyInfo",
      {
        PolicyNumber: claimData.claimInfo.policyInfo.policyNumber,
        PolicyHolderName: claimData.claimInfo.policyInfo.policyHolderName,
        VehicleNo: claimData.claimInfo.policyInfo.vehicleNumber,
        NRIC: claimData.claimInfo.policyInfo.claimantNricNumber,
      },
      null
    )

    const getRequiredDocumentPromise = API.apiPostRequest(
      "/Claim/GetRequiredDocumentList",
      {
        coverageId: Constants.windscreenCoverageIdForDocument,
      },
      null
    )

    Promise.all([validatePolicyPromise, getRequiredDocumentPromise])
      .then(values => {
        let validatePolicyResult = values[0].data
        const category = "claimInfo"
        const targetModel = "claimAttributeModel"

        if (
          validatePolicyResult.ProductType === "MLA" ||
          validatePolicyResult.ProductType === "MMA"
        ) {
          notAllowedClaimAlert()
          dispatch(controlLoading())
          return
        }

        if (
          validatePolicyResult.IsValidPolicy.toLowerCase() === "n" &&
          validatePolicyResult.UpStatus.toLowerCase() === "true"
        ) {
          if (
            (!validatePolicyResult.ProductType &&
              !validatePolicyResult.RiskType) ||
            (validatePolicyResult.ProductType === "MCA" &&
              validatePolicyResult.RiskType !== "MEA")
          ) {
            windscreenPolicyValidationAlert()
          } else {
            windscreenPolicyWithoutVehicleNoValidationAlert()
          }

          dispatch(controlLoading())
        } else {
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "oriStartDate",
              validatePolicyResult.OriStartDate
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "policyStartDate",
              validatePolicyResult.StartDate
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "policyEndDate",
              validatePolicyResult.EndDate
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "upStatus",
              validatePolicyResult.UpStatus
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "riskType",
              validatePolicyResult.RiskType
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "riskNo",
              validatePolicyResult.RiskNo
            )
          )
          dispatch(
            updateCategoryClaimData(
              category,
              targetModel,
              "productType",
              validatePolicyResult.ProductType
            )
          )

          //Check accidentDate is within OriStartDate and PolicyEndDate
          if (
            !Constants.withinPeriod(
              validatePolicyResult.OriStartDate,
              validatePolicyResult.EndDate,
              claimData.claimInfo.policyInfo.accidentDate
            )
          ) {
            accidentDateWithinPolicyPeriodAlert()
            dispatch(controlLoading())
          } else {
            dispatch(increment())
            dispatch(generateFolderName())
            dispatch(storeDocumentList(values[1].data))
            dispatch(controlLoading())
          }
        }
      })
      .catch(error => {
        navigate("ErrorOccurred")
      })

    // dispatch(increment())
    // dispatch(generateFolderName())
    // API.apiPostRequest("/Claim/GetRequiredDocumentList", {
    //   coverageId: Constants.windscreenCoverageIdForDocument,
    // }).then(response => {
    //   dispatch(storeDocumentList(response.data))
    // })
  }
  return (
    <div
      className={
        "FooterClaimTravel container-fluid " + (pageNumber === 6 ? "hide" : "")
      }
    >
      <div className="row" style={{ margin: 0 }}>
        <Container className="FooterDiv">
          <div className={"BackBtnDiv " + (hideBackButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn bg-transparent text-center backBtnSummaryPage"
              onClick={(e) => {
                e.currentTarget.blur(); // remove focus immediately
                previousPage();
              }}
            >
              <i className="fa fa-angle-left" aria-hidden="true"></i> Back
            </button>
          </div>

          <div className={"NextBtnDiv " + (hideNextButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn text-center NextBtn"
              onClick={() => nextPage()}
            >
              {!uiData.showDeclaration ? "Next" : "Submit Claim"}
            </button>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default WindscreenClaimFooter
